/**
 * 用户点赞，收藏等行为的 API,
 * 用户投票使用 poll.service
 */
import { Injectable } from '@angular/core';
import { HttpClientHelper } from '../http-helper';
import { StorageService } from '../../storageprovider';

export enum VotingType {
    'LikeVideo', 'DislikeVideo', 'LikeComment', 'FavoriteVideo', 'UnfavoriteVideo'
}

@Injectable()
export class VotingService {
    constructor(
        private _storage: StorageService
    ) { }

    vote(type, id) {
        const nameOfType = VotingType[type];
        let items = [];
        if (this._storage.GetItem(nameOfType)) {
            items = this._storage.GetItem(nameOfType).split(',');
        }
        if (items.indexOf(id.toString()) > -1) {
            return false;
        }
        items.push(id);
        this._storage.SetItem(nameOfType, items.join(','));
    }

    isVoted(type, id) {
        if (!id) { return false; }
        const nameOfType = VotingType[type];
        if (this._storage.GetItem(nameOfType)) {
            const items = this._storage.GetItem(nameOfType).split(',');
            if (items.indexOf(id.toString()) > -1) {
                return true;
            }
        }
        return false;
    }
}
